export { default, getServerSideProps } from '../src/pages/onboarding';
